// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__tNVOj","input":"Checkbox_input__g1M51","empty":"Checkbox_empty__sQVZ5","full":"Checkbox_full__Uu67t"};